// https://github.com/FlutterInt/fips-shared-protocols/blob/master/gamedefs.h

enum HandType {
  NONE = 0,
  BADUGI = 1,
  HOLDEM = 2,
  OMAHA_5 = 3,
  OMAHA = 4,
  FIVE_CARD_DRAW = 5,
  SINGLE_DRAW_2_7 = 6,
  STUD = 7,
  RAZZ = 8,
  TRIPLE_DRAW_2_7 = 9,
  TRIPLE_DRAW_A_5 = 10,
  COURCHEVEL = 11,
  OMAHA_6 = 12,
  SPLIT_HOLDEM = 13,
  SPLIT_OMAHA = 14,
  SHOWTIME_HOLDEM = 15,
  SHOWTIME_OMAHA = 16,
  FUSION = 17,
  UNFOLD_CLASSIC = 18,
  UNFOLD_MAX = 19,
  SIX_PLUS_HOLDEM = 20,
  DEEPWATER_HOLDEM = 21,
  DEEPWATER_OMAHA = 22,
  SWAP_HOLDEM = 23,
  TEMPEST_HOLDEM = 24,
  TURMOIL_HOLDEM = 25,
  HOSE = 100,
  HORSE = 101,
  EIGHT_GAME = 102,
  MIXED_HOLDEM = 103,
  MIXED_OMAHA = 104,
  POT_LIMIT_HOLDEM_OMAHA = 105,
  TRIPLE_STUD = 106,
  NO_LIMIT_HOLDEM_OMAHA = 107,
  OMAHA_MIXED = 108
}

export default HandType;
